import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb, DropdownButton, MenuItem } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { Selection } from '../Common/selection';
import { UI_HEIGHT } from '../Common/constants';
import RowLabelField from '../Common/RowLabelField';
import CustomerStatementDetailTable from './CustomerStatement/customerStatementDetailTable';
import { ROOT_URL, companyCodeTitle, isDAICHEONG, isLAP, isUSPrideMulti, isAPD, isOLG, isVAK, isSV, isGFD, isGGI, isBRO } from '../../actions/root_url';
import { getFromToDates, dateFormat, toFromDates } from '../Common/cleanDates';
import { numberWithCommas } from '../Common/numberWithCommas';
import checkPermission from '../Common/permissions';
import GenericSelection from '../Common/GenericSelection';
import GenericDatePicker from '../Common/GenericDatePicker';
import genericRadioFilter from '../Common/genericRadioFilter';
import { SkyLightStateless } from 'react-skylight';
import PrintBySalesModal from './PrintBySalesModal';
import EmailContentModal from '../Sales/components/EmailContentModal';
import { getLocalStorageData } from '../../reducers/headerRedux';

momentLocalizer(moment);

const getBsStyle = (input, value) => (input === value ? 'success' : 'primary');

class CustomerStatement extends Component {
  static getQuarter() {
    return Math.ceil((new Date().getMonth() + 1) / 3);
  }
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.customersPage - 100,
      statementLines: [],
      // filteredLines: [],
      invoiceAmount: 0,
      paymentAmount: 0,
      totalBalance: 0,
      remainingBalance: 0,
      forwardedBalance: 0,
      PdfFrameLoaded: true,
      // yearChanged: false,
      // invoiceFilter: 'all',
      fromDate: (isOLG) ? new Date(moment().subtract(7, 'd').toISOString()) : (isLAP || isUSPrideMulti || isAPD) ? new Date(moment().subtract(100, 'Y').toISOString()) : new Date('2017-08-18T00:00:00-0700'),
      toDate: new Date(),
      paymentCutoffDate: new Date(),
      typeRadios: (isLAP || isUSPrideMulti || isAPD) ? 'all' : 'range',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      quarter: CustomerStatement.getQuarter(),
      printBySalesModalVisibility: false,

      emailContentModalVisibility: false,
      emailSubjectTemplate: '',
      emailContentTemplate: '',
    };

    this.setMonthSelected = this.setMonthSelected.bind(this);
    this.setQuarterSelected = this.setQuarterSelected.bind(this);
    this.handleDateFilterChange = this.handleDateFilterChange.bind(this);
    this.setFromDate = this.setFromDate.bind(this);
    this.setToDate = this.setToDate.bind(this);
    this.setPaymentCutoffDate = this.setPaymentCutoffDate.bind(this);
  }

  componentWillMount() {
    // this.props.setDefaultOfForm('typeRadios', 'range', 'customerStatement');
    // this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'customerStatement');
    // this.props.setDefaultOfForm('ToDate', new Date(), 'customerStatement');
    const { currentCustomer, selectedCompany } = this.props;
    if(isVAK && selectedCompany && selectedCompany.value) {
      this.props.fetchCustomers(()=>{}, selectedCompany.value);
    } else {
      if (isGGI) {
        this.props.fetchCustomers(()=>{}, selectedCompany.value, 1);
      } else {
        this.props.fetchCustomers();
      }
    }
    if (currentCustomer && currentCustomer.Deliver_Customer_id) {
      this.props.setValue('customerStatement', 'Customer', { value: currentCustomer.Deliver_Customer_id });
    }
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    // this.props.setDefaultOfForm('StatementType', 'forwarded', 'customerStatement');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customerStatement && nextProps.customerStatement !== this.props.customerStatement) {
      const statementLines = nextProps.customerStatement.ar_payment_lines;
      const invoiceAmount = nextProps.customerStatement.invoice_amount;
      const paymentAmount = nextProps.customerStatement.payment_amount;
      const totalBalance = nextProps.customerStatement.total_balance;
      const remainingBalance = nextProps.customerStatement.remaining_balance;
      const forwardedBalance = nextProps.customerStatement.forwarded_amount;
      // if (this.props.StatementType === 'forwarded') {
      //   forwardedBalance = nextProps.customerStatement.PreviousBalance;
      //   remainingBalance += forwardedBalance;
      // }
      // let filteredLines;
      // const { invoiceFilter } = this.state;
      // if (invoiceFilter !== 'all') {
      //   filteredLines = statementLines.filter(line => line.type === invoiceFilter);
      // } else {
      //   filteredLines = statementLines;
      // }
      this.setState({
        statementLines,
        // filteredLines,
        invoiceAmount,
        paymentAmount,
        totalBalance,
        remainingBalance,
        forwardedBalance
      });
    }
    // if (nextProps.StatementType && nextProps.StatementType !== this.props.StatementType) {
    //   let year = '';
    //   let month = '';
    //   let quarter = '';
    //   let date = -1;
    //   const fromDate = this.props.FromDate ? formatDate(this.props.FromDate) : '1900-01-01';
    //   const toDate = this.props.ToDate ? formatDate(this.props.ToDate) : '3000-01-01';
    //   if (this.props.Customer) {
    //     const customer = this.props.Customer.value || this.props.Customer;
    //     if (this.props.Year) {
    //       year = this.props.Year.value;
    //       if (this.props.Month) {
    //         if (this.props.Month.value < 10) {
    //             month += `0${this.props.Month.value}`;
    //         } else {
    //           month = this.props.Month.value;
    //         }
    //       }
    //       if (this.props.Quarter) {
    //         quarter = this.props.Quarter.value;
    //       }
    //       date = `${year}${month}${quarter}`;
    //       this.props.fetchCustomerStatement(fromDate, toDate, customer, nextProps.StatementType, date);
    //     } else {
    //       this.props.fetchCustomerStatement(fromDate, toDate, customer, nextProps.StatementType, date);
    //     }
    //   }
    // }
    if (nextProps.typeRadios && nextProps.typeRadios !== this.props.typeRadios) {
      this.resetDates();
    }

    // if (!this.props.typeRadios) {
    //   this.props.setDefaultOfForm('typeRadios', 'range', 'customerStatement');
    //   this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'customerStatement');
    //   this.props.setDefaultOfForm('ToDate', new Date(), 'customerStatement');
    // }
    // if (nextProps.Year && nextProps.Year !== this.props.Year) {
    //   this.setState({ yearChanged: !this.state.yearChanged });
    // }

    if (nextProps.Customer && nextProps.Customer !== this.props.Customer) {
      this.props.fetchSalesCustomerDetail(nextProps.Customer.value || nextProps.Customer);
      const statementLines = [];
      const invoiceAmount = 0;
      const paymentAmount = 0;
      const totalBalance = 0;
      const remainingBalance = 0;
      const forwardedBalance = 0;
      this.setState({
        invoiceAmount,
        paymentAmount,
        totalBalance,
        remainingBalance,
        forwardedBalance,
        statementLines,
      });
      // this.resetDates();
      this.fetchCustomerStatement(nextProps);
    }

    if (nextProps.arReport && nextProps.arReport !== this.props.arReport) {
      this.setState({ PdfFrameLoaded: false });
    }
    if(isVAK && nextProps.selectedCompany && nextProps.selectedCompany != this.props.selectedCompany) {
      if(nextProps.selectedCompany.value) {
        this.props.fetchCustomers(()=>{}, nextProps.selectedCompany.value);
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded === false) {
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  setToDate(e) {
    if (!this.props.Customer) {
      alert('Please select a customer!');
      return;
    }
    if (e < this.state.fromDate) {
      return;
    }
    this.setState(
      { toDate: e },
      () => { this.props.fetchCustomerStatement(this.state.fromDate, e, this.props.Customer.value, this.props.StatementType, this.state.paymentCutoffDate); },
    );
  }

  setFromDate(e) {
    if (!this.props.Customer) {
      alert('Please select a customer!');
      return;
    }
    if (e > this.state.toDate) {
      return;
    }
    this.setState(
      { fromDate: e },
      () => { this.props.fetchCustomerStatement(e, this.state.toDate, this.props.Customer.value, this.props.StatementType, this.state.paymentCutoffDate); },
    );
  }

  setMonthSelected(e) {
    if (!this.props.Customer) {
      alert('Please select a customer!');
      return;
    }
    this.setState({ month: e.value }, this.formatFetchMonth);
  }

  setQuarterSelected(e) {
    if (!this.props.Customer) {
      alert('Please select a Customer!');
      return;
    }
    this.setState({ quarter: e.value }, this.formatFetchQuarter);
  }

  getYearOptions() {
    const yearOptions = [];
    let year = (new Date().getFullYear() + 1);
    while (year > 2017) {
      year -= 1;
      yearOptions.push({ value: year, label: year });
    }
    return yearOptions;
  }

  getMonthOptions() {
    const { year } = this.state;
    const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthOptions = [];
    const currentyear = new Date().getFullYear();
    let month = 0;
    if (year) {
      if (year < currentyear) {
        month = 12;
      } else {
        month = new Date().getMonth() + 1;
      }
      for (let i = 1; i < month + 1; i += 1) {
        monthOptions.push({ value: i, label: dateMap[i - 1] });
      }
    }
    return monthOptions;
  }

  getQuarterOptions() {
    const { year } = this.state;
    const quarterOptions = [];
    const currentyear = new Date().getFullYear();
    let quarter = 0;
    if (year) {
      if (year < currentyear) {
        quarter = 4;
      } else {
        const month = new Date().getMonth() + 1;
        quarter = (Math.ceil(month / 3));
      }
    }
    for (let i = 1; i < quarter + 1; i += 1) {
      quarterOptions.push({ value: i, label: i });
    }
    return quarterOptions;
  }

  setPaymentCutoffDate(e) {
    if (!this.props.Customer) {
      alert('Please select a customer!');
      return;
    }
    this.setState(
      { paymentCutoffDate: e },
      () => { this.props.fetchCustomerStatement(this.state.fromDate, this.state.toDate, this.props.Customer.value, this.props.StatementType, e); },
    );
  }

  getCustomerNameOptions() {
    const customerOptions = [];
    this.props.customers.map(customer => {
      customerOptions.push({ value: customer.Customer_id, label: customer.Name });
    });
    return customerOptions;
  }

  getCustomerNumOptions() {
    const customerOptions = [];
    this.props.customers.map(customer => {
      customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum });
    });
    return customerOptions;
  }

  getCustomerPhoneOptions() {
    const customerOptions = [];
    this.props.customers.map(customer => {
      customerOptions.push({ value: customer.Customer_id, label: customer.Telephone });
    });
    return customerOptions;
  }

  getCustomerDescriptionOptions() {
    const customerOptions = [];
    this.props.customers.map(customer => {
      customerOptions.push({ value: customer.Customer_id, label: customer.Description });
    });
    return customerOptions;
  }

  formatFetchMonth() {
    const {
      year, month, typeRadios,
    } = this.state;
    let FromDate = moment([year, month - 1]);
    let ToDate = moment(FromDate).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, typeRadios,
    }, () => { this.props.fetchCustomerStatement(FromDate, ToDate, this.props.Customer.value, this.props.StatementType, this.state.paymentCutoffDate); });
  }

  formatFetchQuarter() {
    const {
      year, quarter, typeRadios,
    } = this.state;
    let FromDate = moment([year, (quarter - 1) * 3]);
    let ToDate = moment([year, (quarter * 3) - 1]).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, typeRadios,
    }, () => { this.props.fetchCustomerStatement(FromDate, ToDate, this.props.Customer.value, this.props.StatementType, this.state.paymentCutoffDate); });
  }

  resetDates() {
    // this.props.setValue('customerStatement', 'FromDate', '');
    // this.props.setValue('customerStatement', 'ToDate', '');
    this.props.setValue('customerStatement', 'Year', '');
    this.props.setValue('customerStatement', 'Month', '');
    this.props.setValue('customerStatement', 'Quarter', '');
  }

  handleResize = () => {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.customersPage - 100 });
  }

  fetchCustomerStatement = (props) => {
    const { Customer, StatementType } = props;
    if (Customer) {
      const customer = Customer.value || Customer;
      // const { fromDate, toDate } = getFromToDatesWithFilter(props);
      this.props.fetchCustomerStatement(this.state.fromDate, this.state.toDate, customer, StatementType, this.state.paymentCutoffDate);
    }
  }

  handleDateFilterChange(type) {
    if (!this.props.Customer) {
      alert('Please select a Customer!');
      return;
    }
    if (type === 'month') {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 }, this.formatFetchMonth);
    } else if (type === 'quarter') {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: CustomerStatement.getQuarter() }, this.formatFetchQuarter);
    } else if (type === 'range' && type !== this.state.typeRadios) {
      this.setState({
        typeRadios: type, fromDate: (isOLG) ? new Date(moment().subtract(7, 'd').toISOString()) : (isLAP || isUSPrideMulti || isAPD) ? new Date(moment().subtract(3, 'M').toISOString()) : new Date('2017-08-18T00:00:00-0700'), toDate: new Date(),
      }, () => { this.props.fetchCustomerStatement(this.state.fromDate, this.state.toDate, this.props.Customer.value, this.props.StatementType, this.state.paymentCutoffDate); });
    } else if (type === 'all') {
      this.setState({
        typeRadios: type, fromDate: new Date('1901-08-18T00:00:00-0700'), toDate: new Date(),
      }, () => { this.props.fetchCustomerStatement(this.state.fromDate, this.state.toDate, this.props.Customer.value, this.props.StatementType, this.state.paymentCutoffDate); });
    }
  }

  handleTypeFilterChange = (event) => {
    const filter = event.target.value;
    const { statementLines } = this.state;
    let filteredLines;
    if (filter !== 'all') {
      filteredLines = statementLines.filter(line => line.type === filter);
    } else {
      filteredLines = statementLines;
    }
    this.setState({
      invoiceFilter: filter,
      filteredLines,
    });
  }

  IFrameIsLoaded = () => {
    if (!this.state.PdfFrameLoaded) {
      const pdfFrame = window.frames["Pdf"];
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoaded: true });
    }
  }

  handlePrintBySales = (printBySalesModalVisibility = false) => {
    this.setState({printBySalesModalVisibility});
  }

  renderIFrame() {
    if (this.props.arReport) {
      const file = window.URL.createObjectURL(this.props.arReport);
      return (
          <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
      );
    }
  }

  renderDateSelector() {
    const yearOptions = this.getYearOptions();
    if (this.state.typeRadios === 'range') {
      return (
        <div>
          <div className="report-table-filters" id="customer-statement-date-selector">
            <label className="from-label">
              <Translate value="from" />
            </label>
            {
              GenericDatePicker({
                ...(isOLG || isLAP || isUSPrideMulti || isAPD) ? {id: 'cust_input1'} : {},
                setDate: this.setFromDate,
                selectedDate: this.state.fromDate,
                onChange: (e) => {
                  this.setFromDate(e);
                },
              })
            }
            <label className="to-label">
              <Translate value="to" />
            </label>
            {
              GenericDatePicker({
                ...(isOLG || isLAP || isUSPrideMulti || isAPD) ? {id: 'cust_input2'} : {},
                setDate: this.setToDate,
                selectedDate: this.state.toDate,
                onChange: (e) => {
                  this.setToDate(e);
                },
              })
            }
          </div>
        </div>
      );
    } else if (this.state.typeRadios === 'month') {
      const monthOptions = this.getMonthOptions();
      return (
        <Col xs={12}>
          <div className="report-table-filters" id="customer-statement-date-selector">
            {
              GenericSelection({
                translation: <Translate value="year" />,
                options: yearOptions,
                value: this.state.year,
                setSelected: (e) => { this.setState({ year: e.value }); },
              })
            }
            {
              GenericSelection({
                translation: <Translate value="month" />,
                options: monthOptions,
                value: this.state.month,
                setSelected: this.setMonthSelected,
              })
            }
          </div>
        </Col>
      );
    } else if  (this.state.typeRadios === 'all') {
      return (
        <Col xs={12}>
          <div className="report-table-filters" id="customer-statement-date-selector">
          
          </div>
        </Col>
      );
    }
    const quarterOptions = this.getQuarterOptions();
    return (
      <Col xs={12}>
        <div className="report-table-filters" id="customer-statement-date-selector">
          {
            GenericSelection({
              translation: <Translate value="year" />,
              options: yearOptions,
              value: this.state.year,
              setSelected: (e) => { this.setState({ year: e.value }); },
            })
          }
          {
            GenericSelection({
              translation: <Translate value="quarter" />,
              options: quarterOptions,
              value: this.state.quarter,
              setSelected: this.setQuarterSelected,
            })
          }
        </div>
      </Col>
    );
  }

  renderCustomerPaymentTerm = () => {
    // this.props.customers.filter(customer => customer)
    if (this.props.salesCustomerDetails) {
      return this.props.salesCustomerDetails.PaymentTermDesc
    }
    return  'N/A';
  }

  renderCustomerDetail() {
    const customerNameOptions = this.getCustomerNameOptions();
    const customerNumOptions = this.getCustomerNumOptions();
    const customerPhoneOptions = this.getCustomerPhoneOptions();
    const customerDescriptionOptions = this.getCustomerDescriptionOptions();
    return (
      <Row>
        {/* Customer Details */}
        <Col xs={4} id="customer-details">
          <h4><Translate value="customer_information" /></h4>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="name" /><span className="asteriksReq" >*</span> </label>
            <div id="customer-name-dropdown" className="col-xs-8">
              <Field name="Customer" component={Selection} matchPos="any" options={customerNameOptions} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="cust_no" /></label>
            <div id="customer-id-dropdown" className="col-xs-8">
              <Field name="Customer" component={Selection} matchPos="any" options={customerNumOptions} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="phone" /></label>
            <div id="customer-phone-dropdown" className="col-xs-8">
              <Field name="Customer" component={Selection} matchPos="any" options={customerPhoneOptions} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="payment_term" /></label>
            <div className="col-xs-8">
              { this.renderCustomerPaymentTerm()}
            </div>
          </div>
        </Col>
        {/* Billing Information */}
        <Col xs={4} xsOffset={1} id="billing-info">
          <h4><Translate value="billing_information" /></h4>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="contact" /></label>
            <Col xs={9}>
              {
                !this.props.salesCustomerDetails &&
                <label className="text-nowrap">
                  <Translate value="please_select_a_customer" />
                </label>
              }
              {
                this.props.salesCustomerDetails &&
                <span>
                 {this.props.salesCustomerDetails.Contact}
               </span>
              }
            </Col>
          </div>
          <div className="form-group">
            <label className="col-xs-3">
              <Translate value="phone" />
            </label>
            {
              this.props.salesCustomerDetails &&
              <div className="col-xs-9">
                {this.props.salesCustomerDetails.Telephone}
              </div>
            }
          </div>
          <div className="form-group mb0">
            <label className="col-xs-3">
              <Translate value="address" />
            </label>
            {
              this.props.salesCustomerDetails &&
              <div className="col-xs-9">
                <div>{this.props.salesCustomerDetails.Address1}</div>
                <div>{this.props.salesCustomerDetails.Address2}</div>
              </div>
            }
          </div>
        </Col>
          {/* <Col xs={6} id='customer-details'>
            <div className='form-group'>
              <label className='col-xs-3'><Translate value="description" /></label>
              <div id='customer-description-dropdown' className='col-xs-8'>
                <Field name='Customer' component={Selection} matchPos='any' options={customerDescriptionOptions} />
              </div>
            </div>
          </Col> */}
      </Row>
    );
  }

  renderAmountDetail() {
    const {
      invoiceAmount,
      paymentAmount,
      totalBalance,
      remainingBalance,
      forwardedBalance
    } = this.state;
    // const { StatementType } = this.props;
    // const renderprevious = () => {
    //   if (StatementType === 'forwarded') {
    //     return (
    //       <RowLabelField
    //         translation='previous_balance_forward: '
    //         value={`$${forwardedBalance}`}
    //       />
    //     );
    //   }
    // };
    return (
      <Col xs={2} id='zmount-details'>
        {/* renderprevious() */}
        <RowLabelField
          translation='balance_forward:'
          value={`$${numberWithCommas(forwardedBalance)}` || 0}
          right={5}
        />
        <RowLabelField
          translation='total_invoice_amount:'
          value={`$${numberWithCommas(invoiceAmount)}` || 0}
          right={5}
        />
        <RowLabelField
          translation='total_payment:'
          value={`$${numberWithCommas(paymentAmount)}` || 0}
          right={5}
        />
        <RowLabelField
          translation='outstanding_balance:'
          value={`$${numberWithCommas(totalBalance)}` || 0}
          right={5}
        />
        <RowLabelField
          translation='remaining_balance:'
          value={`$${numberWithCommas(remainingBalance)}` || 0}
          right={5}
        />
      </Col>
    );
  }

  renderTable() {
    if (this.props.customerStatementIsLoading && !this.props.customerStatementError) {
      return (
        <div id='spinner'>
          <Spinner />
        </div>
      );
    } else if (this.props.customerStatementError) {
      return (
        <ContentWrapper>
         <div className='alert alert-danger'>
           <Translate value="something_unexpected_happened" />
         </div>
        </ContentWrapper>
      );
    }
    const { statementLines } = this.state;
    return (
      <Row>
        <Col sm={12}>
          <div className='react-table-ar-ap-customer-statement'>
            <CustomerStatementDetailTable
              rows={statementLines}
              minHeight={500}
              onSalesInvoiceNumDoubleClick={this.props.printSalesInvoiceForCustomerStatement}
              onSalesReturnNumDoubleClick={this.props.printSalesInvoiceReturn}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderPrintBySalesButton = () => {
    if (isDAICHEONG) {
      return <Button
        bsStyle='primary'
        type='button'
        onClick={() => this.handlePrintBySales(true)}
        disabled={!checkPermission('print_customer_statement')}
      >
        <em className='fa fa-print' />
        <Translate value="print_by_sales" />
      </Button>
    }
  }

  renderSendEmailButtonTemplate = () => {
    const { Customer } = this.props;
    let customer = null;
    if (Customer) {
      customer = Customer.value || Customer;
    }
    // const { selectedRows } = this.state;
    // const salesOrder_id =
    //   this.state.selectedRows.length === 1 &&
    //   this.state.selectedRows[0].SalesOrder_id;

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={!customer}
        type="button"
        onClick={() => {
          this.setState({
            emailSubjectTemplate: this.genSubjectTemplate(),
            emailContentTemplate: this.genContentTemplate(),
            emailContentModalVisibility: true,
            source: "CS",
          })
        }}
      >
        <Translate value={isOLG ? "email_statement" : "send_statement"} />
      </Button>
    );
  }


  genSubjectTemplate = () => {
    // const row = this.state.selectedRows[0];
    const activeCompany = getLocalStorageData('selectedCompany').label;
    // if(row) {
      // const poNum = row.PONum;
      return `Customer Statement from ${activeCompany.toUpperCase()}`
    // }
  // return ''
}

genContentTemplate = () => {
    const activeCompany = getLocalStorageData('selectedCompany').label;
    return `Dear Customer:

Your Customer Statement is attached. Please review the list of items.
Thank you for your business - we appreciate it very much

Sincerely,
${activeCompany.toUpperCase()}.`
}

handleEmailContentClose = () => {
  this.setState({
    emailContentModalVisibility: false,
    emailSubjectModalTemplate: '',
    emailContentModalTemplate: ''
  })
}

handleEmailContentConfirm = (subject, content, email, phone, sendEmail, source) => {
  const { Customer } = this.props;
  let { fromDate, toDate } = this.state;
  const dates = toFromDates(-1, fromDate, toDate);
  const paymentCutoffDate = getFromToDates(this.state.paymentCutoffDate).toDate;
  let customer = null;
  if (Customer) {
    customer = Customer.value || Customer;
  }
  // const row = this.state.selectedRows[0];
  // if(row) {
    if(isOLG) {
      if(!sendEmail) {
        alert('Customer billing email is empty, please set email first ');
        this.handleEmailContentClose();
        return
      }
      this.props.printARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, true, true, sendEmail, subject, content);
      this.handleEmailContentClose();
      return
    }
    if (customer) {
      this.props.emailPOPost(customer, subject, content, email, phone, sendEmail, source, dates.fromDate, dates.toDate, paymentCutoffDate);
      this.handleEmailContentClose();
    }
  // }
}


  renderToolbarButtons() {
    const { Customer } = this.props;
    const activeCompany = getLocalStorageData('selectedCompany')
    const activeWarehouse =  getLocalStorageData('selectedWarehouse');
    let { fromDate, toDate } = this.state;
    const dates = toFromDates(-1, fromDate, toDate);
    let customer;
    if (Customer) {
      customer = Customer.value || Customer;
    }
    const paymentCutoffDate = getFromToDates(this.state.paymentCutoffDate).toDate;
    const token = localStorage.getItem('token');
    const arUrl = customer
      ? `/AR/new?cust_id=${customer}`
      : '/AR/new';
      
    let warehouse = '';
    if (isGFD && activeWarehouse) {
      warehouse = `&warehouse_id=${activeWarehouse.value}`;
    }
    let simplifiedExport = `${ROOT_URL}v1/ar/report/aged/${customer}/simplifiedexcel/?start_date=${dates.fromDate}&end_date=${dates.toDate}&cut_off_date=${paymentCutoffDate}${warehouse}&Bearer=${token}`;
    let detailedExport = `${ROOT_URL}v1/ar/report/aged/${customer}/excel/?start_date=${dates.fromDate}&end_date=${dates.toDate}&cut_off_date=${paymentCutoffDate}${warehouse}&Bearer=${token}`;
    return (
      <ButtonToolbar>
        <Button
          bsStyle="success"
          type="button"
          href={arUrl}
          disabled={!checkPermission('change_account_receivable')}
        >
          <em className="fa fa-plus" />
          <Translate value="create_ar" />
        </Button>
        <Button
          bsStyle='success'
          type='button'
          href={simplifiedExport}
          disabled={!customer || !checkPermission('print_customer_statement')}
        >
          <em className='fa fa-download' />
          <Translate value="simplified_excel" />
        </Button>
        <Button
          bsStyle='success'
          type='button'
          href={detailedExport}
          disabled={!customer || !checkPermission('print_customer_statement')}
        >
          <em className='fa fa-download' />
          <Translate value="detailed_excel" />
        </Button>
        {(isLAP || isUSPrideMulti || isAPD || isOLG || isGFD || isBRO) && this.renderSendEmailButtonTemplate()}
        <DropdownButton
          bsStyle="primary"
          disabled={!customer || !checkPermission('print_customer_statement')}
          title={<span>
             <em className='fa fa-print' />
             <Translate value="print_statements" />
           </span>}
          noCaret
          id="dropdown-statement"
        >
          <MenuItem
            eventKey="1"
            onSelect={() => { this.props.printARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, false); }
            }
          ><Translate value="detailed_statement" />
          </MenuItem>
          <MenuItem
            eventKey="2"
            onSelect={() => { this.props.printARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, true); }
            }
          ><Translate value="simplified_statement" />
          </MenuItem>
          <MenuItem
            eventKey="3"
            onSelect={() => { this.props.printPlainARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, 'print'); }
            }
          ><Translate value={isSV ? "ar_statement2" : "detailed_plain_statement"} />
          </MenuItem>
          <MenuItem
            eventKey="4"
            onSelect={() => { this.props.printPlainARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, 'simplified-print'); }
            }
          ><Translate value={isSV ? "ar_statement" : "simplified_plain_statement"} />
          </MenuItem>
          <MenuItem
            eventKey="5"
            onSelect={() => { this.props.printPlainARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, 'monthly-print'); }
            }
          ><Translate value="monthly_statement" />
          </MenuItem>
          <MenuItem
            eventKey="6"
            onSelect={() => { this.props.printPlainARReport(customer, dates.fromDate, dates.toDate, paymentCutoffDate, 'payment-term-print'); }
            }
          ><Translate value="payment_term" />
          </MenuItem>
        </DropdownButton>
        {this.renderPrintBySalesButton()}
        <Button
          bsStyle='danger'
          type='button'
          onClick={() => { this.props.router.push('/customerStatementMain'); }}
        >
          <Translate value="back" />
        </Button>
      </ButtonToolbar>
    );
  }

  renderPrintBySalesModal = () => {
    const styles = {
      width: '1000px',
      height: '690px',
      marginLeft: '-32%',
      marginTop: '-20%',
    };
    return <SkyLightStateless
      dialogStyles={styles}
      isVisible={this.state.printBySalesModalVisibility}
      onCloseClicked={() => {
        this.handlePrintBySales();
      }}
      title={<Translate value="print_by_sales" />}
    >
      <PrintBySalesModal />
    </SkyLightStateless>
  }

  render() {
    const { Customer } = this.props;
    let customer = null;
    if (Customer) {
      customer = Customer.value || Customer;
    }
    if(isOLG || isLAP || isUSPrideMulti || isAPD) {
      let rangeInput1 = document.getElementById('cust_input1_input');
      let rangeInput2 = document.getElementById('cust_input2_input');
      let rangeInput3 = document.getElementById('cust_input3_input');
      let span1 = document.querySelector('#cust_input1 .rw-select .rw-btn');
      let span2 = document.querySelector('#cust_input2 .rw-select .rw-btn');
      let span3 = document.querySelector('#cust_input3 .rw-select .rw-btn');
      if(rangeInput1) {
        rangeInput1.disabled = true;
      }
      if(rangeInput2) {
        rangeInput2.disabled = true;
      }
      if(rangeInput3) {
        rangeInput3.disabled = true;
      }
      if(span1) {
        span1.style.background = 'white'
      }
      if(span2) {
        span2.style.background = 'white'
      }
      if(span3) {
        span3.style.background = 'white'
      }
    }
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="ar_slashsign_ap" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active='true'>
            <Translate value="customer_statement" />
          </Breadcrumb.Item>
        </Breadcrumb>

        { this.renderToolbarButtons() }
        { this.renderPrintBySalesModal() }
        <Grid id='customer-statement'>
          {/* Date Range Pickers  */}
          <Row>
            <Col xs={12}>
              <fieldset className='form-horizontal'>
                <Panel id='customer-statement-customer-info'>
                  {this.renderCustomerDetail()}
                </Panel>
              </fieldset>
            </Col>
          </Row>
          <Panel id='date-range-picker' className='form-horizontal'>
            <Row>
              <Col xs={1} id="filter-title-center">
                <h3 className="text-right"><Translate value="statement_range" /><span className="colon">:</span></h3>
              </Col>
              <Col xs={5}>
                <div id="status-filter-radios">
                  {
                    genericRadioFilter({
                      content: (isLAP || isUSPrideMulti || isAPD) ? [
                        {
                          option: 'all',
                          id: 'all-radio-filter',
                          name: 'dateFilterRadios',
                          labelName: 'all',
                        },
                        {
                            option: 'range',
                            id: 'dateRange-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'date_range',
                        },
                        {
                            option: 'quarter',
                            id: 'quarter-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'quarter',
                        },
                        {
                            option: 'month',
                            id: 'month-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'month',
                        },
                      ] : [
                        {
                            option: 'range',
                            id: 'dateRange-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'date_range',
                        },
                        {
                            option: 'quarter',
                            id: 'quarter-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'quarter',
                        },
                        {
                            option: 'month',
                            id: 'month-radio-filter',
                            name: 'dateFilterRadios',
                            labelName: 'month',
                        },
                      ],
                      value: this.state.typeRadios,
                      handleOnClick: this.handleDateFilterChange,
                      type: 'buttons',
                    })
                  }
                </div>
                {this.renderDateSelector()}
              </Col>
              <Col xs={1} id="filter-title-center">
                <h3 className="text-right"><Translate value="payment_cutoff_date" /><span className="colon">:</span></h3>
              </Col>
              <Col xs={2} id="status-filter-radios">
                <div>
                  {
                    GenericDatePicker({
                      ...(isOLG || isLAP || isUSPrideMulti || isAPD) ? {id: 'cust_input3'} : {},
                      setDate: this.setPaymentCutoffDate,
                      selectedDate: this.state.paymentCutoffDate,
                    })
                  }
                </div>
                <p style={{position: "relative", left: "5px", top: "3px"}}>(<Translate value="simplified_statement_only" />)</p>
              </Col>
              {this.renderAmountDetail()}
            </Row>
          </Panel>
          <Row>
            <Col xs={12}>
              <Panel className='position-relative table-collapse-fix mb0'>
                {/* Render Inventory Table  */}
                { this.renderTable() }
              </Panel>
            </Col>
          </Row>
        </Grid>
        {this.renderIFrame()}

        <EmailContentModal
          visible={this.state.emailContentModalVisibility}
          subject={this.state.emailSubjectTemplate}
          content={this.state.emailContentTemplate}
          onConfirm={this.handleEmailContentConfirm}
          onClose={this.handleEmailContentClose}
          selectedRows={[{Deliver_Customer_id: customer}]}
          source={"CS"}
        />
      </ContentWrapper>
    );
  }
}

export default CustomerStatement;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/customerStatement.jsx